import Grid from '@mui/material/Grid';
import { Chip, TextV2 } from '@insights-ltd/design-library/components';
import { stringTruncate } from '@insights-ltd/design-library/utils';
import { Box, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { TeamResponse } from 'api';

const LearnerCountColumn = ({
  learnerCount,
  migrated,
  location,
}: Pick<TeamResponse, 'learnerCount' | 'migrated' | 'location'>) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        '& > div': {
          marginLeft: '4px',
        },
      }}
    >
      <TextV2 component="span" variant="bodyBold" color="textSecondary">
        {t('ui.event-management.teams.learners-count', {
          count: learnerCount,
        })}
      </TextV2>
      {migrated && (
        <>
          <Chip
            label={t('ui.event-management.teams.permissions.label-migrated')}
            color="pink"
          />

          {location && (
            <Grid
              sx={{
                flex: '1',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
              }}
              size="auto"
            >
              <Tooltip placement="top-end" title={location}>
                <Typography aria-label={location}>
                  {stringTruncate(location, 24, 9)}
                </Typography>
              </Tooltip>
            </Grid>
          )}
        </>
      )}
    </Box>
  );
};

export default LearnerCountColumn;
